import { NavigateFunction } from "react-router-dom";

export function navigateBack(
  navigate: NavigateFunction,
  fallbackRoute?: string,
): void {
  if (window.history.length > 1) {
    navigate(-1);
  } else if (fallbackRoute) {
    navigate(fallbackRoute);
  }
}
